module.exports = __webpack_public_path__ + "static/media/no-stats-bars.0f5b7b75.svg";